import { makeAutoObservable, reaction } from "mobx";
import { RArray } from "../collections";
import { Tracking } from ".";
import { OrderLinePrice } from "../pricing/OrderLinePrice";
// TODO: persist trackingData in localStorage?
const trackingData = new Map();
export const PurchaseOrderPayloadTracking = {
    collectCreatorData,
    collectProductData,
    trackingData,
    createReactions(params) {
        return new PurchaseOrderPayloadTrackingReactions(params);
    },
};
function collectCreatorData(productCardCreator) {
    collectProductData(productCardCreator.productInstanceCreator.instance.trackingId, "Menu");
    productCardCreator.crossSellingCreator.selectedItems.forEach(([creator]) => collectProductData(creator.instance.trackingId, "CreatorCrossSelling"));
}
function collectProductData(trackingId, list) {
    trackingData.set(trackingId, list);
}
class PurchaseOrderPayloadTrackingReactions {
    constructor(params) {
        this.purchaseOrderPayload = params.purchaseOrderPayload;
        this.productTypes = params.productTypes;
        makeAutoObservable(this);
    }
    initialize() {
        if (this.disposer) {
            throw new Error("PurchaseOrderReactions has been already initialized");
        }
        this.disposer = reaction(() => this.purchaseOrderPayload.orderLines, (orderLines, prevOrderLines) => {
            // Track "AddToCart" event
            this.getOrderLinesDiff(orderLines, prevOrderLines)
                .map((orderLine) => this.orderLineToItem(orderLine))
                .forEach((contents) => {
                Tracking.trackEvent({ tag: "AddToCart", contents });
            });
            // Track "RemoveFromCart" event
            this.getOrderLinesDiff(prevOrderLines, orderLines)
                .map((orderLine) => this.orderLineToItem(orderLine))
                .forEach((contents) => {
                Tracking.trackEvent({ tag: "RemoveFromCart", contents });
            });
        });
    }
    getOrderLinesDiff(a, b) {
        return a.filtered((aItem) => b.firstIndexWhere((bItem) => aItem.productInstance.trackingId ===
            bItem.productInstance.trackingId) === null);
    }
    orderLineToItem(orderLine) {
        var _a, _b, _c;
        const productTypes = new RArray(orderLine.productTypeIds.rawValues()).mapOptional((productTypeId) => this.productTypes.find(productTypeId));
        return {
            name: productTypes.map((productType) => productType.name).raw.join("/"),
            price: (_b = (_a = OrderLinePrice.unitPrice(orderLine).finalValue) === null || _a === void 0 ? void 0 : _a.asNumber) !== null && _b !== void 0 ? _b : 0,
            // NOTICE: Domain decrements orderLine's quantity first and separately filters visible orderLines with "not empty" rule
            // So there is a case when orderLine's quantity is 0. But for analytics we need to track it as 1 to compute order line value (price * quantity)
            // To fix this we can create a subscribtion based orderLine list & observe it's changes to send events (before domain decrements quantity)
            quantity: orderLine.quantity.value === 0 ? 1 : orderLine.quantity.value,
            category: productTypes.get(0).categoryName,
            list: (_c = trackingData.get(orderLine.productInstance.trackingId)) !== null && _c !== void 0 ? _c : null,
        };
    }
    dispose() {
        if (this.disposer) {
            this.disposer();
        }
    }
}
